import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../components/SuperAdminLayout.css';

// Sign in for the Run The Club admin site. Only super admins get in; club
// members are told to use their club's own site.
export default function AdminLogin() {
  const { login, logout, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [working, setWorking] = useState(false);

  useEffect(() => { document.title = 'Sign in · Run The Club admin'; }, []);
  useEffect(() => {
    if (user?.role === 'SUPER_ADMIN') navigate('/super-admin', { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setWorking(true);
    setError(null);
    const result = await login(email, password);
    setWorking(false);
    if (!result.success) return setError(result.error || "That email and password don't match");
    if (result.user?.role !== 'SUPER_ADMIN') {
      logout();
      setError("This sign-in is for Run The Club staff. Club members sign in on their club's own site.");
    }
  };

  return (
    <div className="rtc-shell rtc-login">
      <form className="rtc-login__card" onSubmit={submit}>
        <p className="rtc-bar__brand rtc-login__brand">Run The Club <span className="rtc-bar__tag">Admin</span></p>
        <h1>Sign in</h1>
        <label htmlFor="rtc-email">Email</label>
        <input id="rtc-email" type="email" autoComplete="username" value={email} onChange={e => setEmail(e.target.value)} required />
        <label htmlFor="rtc-password">Password</label>
        <input id="rtc-password" type="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} required />
        {error && <p className="rtc-login__error" role="alert">{error}</p>}
        <button type="submit" disabled={working}>{working ? 'Signing in...' : 'Sign in'}</button>
        <Link to="/forgot-password" className="rtc-login__link">Forgot your password?</Link>
      </form>
    </div>
  );
}
